import { render } from "./objecttypes.vue?vue&type=template&id=c4e7c634"
import script from "./objecttypes.vue?vue&type=script&lang=js"
export * from "./objecttypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__